export default function () {
  if (window && window.skeleton) {
    window.skeleton.close();
  }
}



// WEBPACK FOOTER //
// ../src/plugin/prototype/closeSkeleton.js